/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IParameterDropZoneInputScope extends ng.IScope {
        parameter: Wars.Domain.Model.OperationParameter;
        isReadonly: boolean;
        typedInValue: string;
        typedInValueChanged: () => void;
        getTreeItemName: (treeItem: Wars.Domain.Model.TreeItem) => string;
        getTreeItemIconName: (treeItem: Wars.Domain.Model.TreeItem) => string;
        getParentDisplayName: (treeItem: Wars.Domain.Model.TreeItem) => string;
        onDragOver: ($event: any) => void;
        onDrop: ($event: any) => void;
        isInlineConstant: () => boolean;
        detailedTreeItemDisplay: string;
        treeItemDisplayInternal: string;
    }

    export class ParameterDropZoneInput implements IDirective {
        public templateUrl: string = './app/views/directives/calculate/parameterDropZoneInput.html';
        public restrict: string = 'E';
        public controller = ['$scope', 'calculationService', 'treeService', 'treeItemService', ParameterDropZoneInputController];
        public controllerAs = 'controller';
        public scope: any = {
            parameter: "=",
            isReadonly: "="
        };

        public link($scope: IParameterDropZoneInputScope, element: JQuery, attrs: ng.IAttributes, controller: ParameterDropZoneInputController) { }
    }

    export class ParameterDropZoneInputController implements IController {
        private $scope: IParameterDropZoneInputScope;

        constructor(
            $scope: IParameterDropZoneInputScope,
            private calculationService: services.CalculationService,
            private treeService: services.TreeService,
            private treeItemService: services.TreeItemService,
            private constantService: services.ConstantService)
        {
            this.$scope = $scope;
            this.setTypedInValue();

            this.$scope.typedInValueChanged = () => this.typedInValueChangedInternal();
            this.$scope.getTreeItemName = (treeItem: Wars.Domain.Model.TreeItem) => this.getTreeItemNameInternal(treeItem);
            this.$scope.getTreeItemIconName = (treeItem: Wars.Domain.Model.TreeItem) => this.getTreeItemIconNameInternal(treeItem);
            this.$scope.onDragOver = ($event: any) => this.onDragOverInternal($event);
            this.$scope.onDrop = ($event: any) => this.onDropInternal($event);
            this.$scope.isInlineConstant = () => this.isInlineConstantInternal();

            // When the normal display of the tree item changes update the detailed display.
            this.$scope.$watch("treeItemDisplayInternal",
                () => {
                    this.updateDetailedTreeItemDisplay();
                });
        }

        private isInlineConstantInternal() : boolean {
            if (!this.$scope.parameter || !this.$scope.parameter.treeItem || !this.$scope.parameter.treeItem.constantValue) return false;
            return !this.$scope.parameter.treeItem.constantValue.processConfiguration_id && !this.$scope.parameter.treeItem.constantValue.systemLevel_id;
        }

        private setTypedInValue(): void {
            if (this.$scope.parameter && this.$scope.parameter.treeItem && this.$scope.parameter.treeItem.constantValue) {
                switch (this.$scope.parameter.treeItem.constantValue.variableType) {
                    case Wars.Domain.Model.Codes.Enums.VariableType.Integer:
                        this.$scope.typedInValue = this.$scope.parameter.treeItem.constantValue.integerValue.toString();
                        break;

                    case Wars.Domain.Model.Codes.Enums.VariableType.Decimal:
                        this.$scope.typedInValue = this.$scope.parameter.treeItem.constantValue.decimalValue.toString();
                        break;

                    case Wars.Domain.Model.Codes.Enums.VariableType.String:
                        this.$scope.typedInValue = this.$scope.parameter.treeItem.constantValue.stringValue;
                        break;
                }
            }
        }

        private getTreeItemNameInternal(treeItem: Wars.Domain.Model.TreeItem) {
            if (!treeItem) {
                this.$scope.treeItemDisplayInternal = '';
                return this.$scope.treeItemDisplayInternal;
            }
            this.$scope.treeItemDisplayInternal = this.treeService.getDisplayName(treeItem) + ' of ' + this.treeService.getParentDisplayName(treeItem);
            return this.$scope.treeItemDisplayInternal;
        }

        private getTreeItemIconNameInternal(treeItem: Wars.Domain.Model.TreeItem): string {
            if (!treeItem) return '';
            return this.treeService.getParentDisplayIcon(treeItem);
        }

        private onDragOverInternal($event: any): void {
            var treeConfig = this.treeService.getTreeConfigurationItem();
        }

        private onDropInternal($event: any): void {

            var self = this;
            var newTreeItem = this.treeService.createTreeItemFromItemDropped(() => {
                if (self.treeService.doesTreeItemHaveParameters(newTreeItem)) {
                    alert("Cannot drag a tree item that take parameters into a parameter input");
                    newTreeItem.entityAspect.setDeleted();
                } else {
                    self.calculationService.isTypedInConstant(self.$scope.parameter.treeItem.constantValue)
                    {
                        self.$scope.parameter.treeItem.constantValue.entityAspect.setDeleted();
                    }
                    self.$scope.parameter.treeItem.entityAspect.setDeleted();

                    self.$scope.parameter.treeItem = newTreeItem;
                    self.$scope.parameter.treeItem_id = newTreeItem.id;
                }

                this.treeService.clearDragValue();
            });

            $event.preventDefault();
            $event.stopPropagation();
        }

        private typedInValueChangedInternal(): void {
            // Check for just whitespace
            if (this.$scope.typedInValue.trim().length === 0) {
                if (this.$scope.parameter.treeItem && this.$scope.parameter.treeItem.constantValue) {
                    this.$scope.parameter.treeItem.constantValue.integerValue = undefined;
                    this.$scope.parameter.treeItem.constantValue.decimalValue = undefined;
                    this.$scope.parameter.treeItem.constantValue.stringValue = undefined;
                }
            } else {
                if (this.isAnInt(this.$scope.typedInValue)) {
                    this.setIntConstantValue(parseInt(this.$scope.typedInValue));
                } else if (this.isAFloat(this.$scope.typedInValue)) {
                    this.setDecimalConstantValue(parseFloat(this.$scope.typedInValue));
                } else {
                    this.setStringConstantValue(this.$scope.typedInValue);
                }
            }
        }

        private setIntConstantValue(intValue: number): void {
            this.$scope.parameter.treeItem.constantValue.variableType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
            this.$scope.parameter.treeItem.constantValue.integerValue = intValue;
            this.$scope.parameter.treeItem.constantValue.decimalValue = undefined;
            this.$scope.parameter.treeItem.constantValue.stringValue = undefined;
        }

        private setDecimalConstantValue(decimalValue: number): void {
            this.$scope.parameter.treeItem.constantValue.variableType = Wars.Domain.Model.Codes.Enums.VariableType.Decimal;
            this.$scope.parameter.treeItem.constantValue.integerValue = undefined;
            this.$scope.parameter.treeItem.constantValue.decimalValue = decimalValue;
            this.$scope.parameter.treeItem.constantValue.stringValue = undefined;
        }

        private setStringConstantValue(stringValue: string): void {
            this.$scope.parameter.treeItem.constantValue.variableType = Wars.Domain.Model.Codes.Enums.VariableType.String;
            this.$scope.parameter.treeItem.constantValue.integerValue = undefined;
            this.$scope.parameter.treeItem.constantValue.decimalValue = undefined;
            this.$scope.parameter.treeItem.constantValue.stringValue = stringValue;
        }

        private isAnInt(value: any): boolean {
            return Number(value) == value && value % 1 === 0;
        }

        private isAFloat(value: any): boolean {
            return Number(value) == value && value % 1 !== 0;
        }

        private updateDetailedTreeItemDisplay(): void {
            if (this.$scope.treeItemDisplayInternal === undefined ||
                this.$scope.treeItemDisplayInternal === null ||
                this.$scope.treeItemDisplayInternal === "") {
                return;
            }

            if (this.$scope.parameter === undefined || this.$scope.parameter === null) return;
            var treeItem = this.$scope.parameter.treeItem;
            if (!treeItem) return;
            if (!treeItem.id) return;

            this.treeService.getDetailedDisplayName(treeItem).then((detailedDisplay) => {
                this.$scope.detailedTreeItemDisplay = detailedDisplay;
            });
        }
    }
}

warsApp.registerDirective('ParameterDropZoneInput', []);